module.exports = __webpack_public_path__ + "static/media/no-diamond.bd6c6dc4.png";